import './App.css';
import Navbar from './components/Navbar';
import Tasks from './components/Tasks';
function App() {
  return (
    <>
      <Navbar />
      <Tasks />
    </>
  )
}

export default App;
